require('jquery.payment.js');
$.payment.cards.push({
  type: 'discover',
  patterns: [60, 64, 65, 622],
  format: /(\d{1,4})(\d{1,4})?(\d{1,4})?(\d{1,4})?(\d{1,3})?/,
  length: [16, 17, 18, 19],
  cvcLength: [3],
  luhn: true
});


/*****************
 ** WEBPACK FOOTER
 ** ./assets/vendor/jquery.payment.extended.js
 ** module id = 198
 ** module chunks = 1 2 3 8 9 15 83 101 146 191
 **/